"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSUBSCRIBE_AS_CHAT_V2_USER_WS_EVENT_NAME = exports.SUBSCRIBE_AS_CHAT_V2_USER_SUCCESS_WS_EVENT_NAME = exports.SUBSCRIBE_AS_CHAT_V2_USER_WS_EVENT_NAME = void 0;
exports.SUBSCRIBE_AS_CHAT_V2_USER_WS_EVENT_NAME = 'subscribe as chat_v2_user';
exports.SUBSCRIBE_AS_CHAT_V2_USER_SUCCESS_WS_EVENT_NAME = 'subscribe as chat_v2_user success';
exports.UNSUBSCRIBE_AS_CHAT_V2_USER_WS_EVENT_NAME = 'unsubscribe as chat_v2_user';
//# sourceMappingURL=realtime_types.js.map